import { render, staticRenderFns } from "./ModalBeneficio.vue?vue&type=template&id=3c83bba1&scoped=true&"
import script from "./ModalBeneficio.vue?vue&type=script&lang=js&"
export * from "./ModalBeneficio.vue?vue&type=script&lang=js&"
import style0 from "./ModalBeneficio.vue?vue&type=style&index=0&id=3c83bba1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c83bba1",
  null
  
)

export default component.exports